import {Component, OnDestroy, OnInit} from '@angular/core';
import {Aplikacia} from '../model/aplikacia';
import {Subscription} from 'rxjs';
import {AppService} from '../app.service';

@Component({
  selector: 'app-aplikacie',
  templateUrl: './aplikacie.component.html',
  styleUrls: ['./aplikacie.component.css']
})
export class AplikacieComponent implements OnInit, OnDestroy {

  data: Aplikacia[];
  aplikacieData: Subscription;
  loading = false;

  constructor(private appService: AppService) { }

  ngOnInit() {
    this.aplikacieData = this.appService.aplikacieData
      .subscribe((data) => {
        this.data = data.filter((a: Aplikacia) => {
          return a.type === 'list';
        }).sort((a: Aplikacia, b: Aplikacia) => {
          return a.ordering - b.ordering;
        });
        this.loading = false;
      });

    this.loading = true;
    this.appService.fetchAplikacie();
  }

  ngOnDestroy(): void {
    this.aplikacieData.unsubscribe();
  }

  openApplication(app: Aplikacia) {
    this.appService.openAppWindow(app);
  }
}
